"use client";

import { useEffect, useRef, useState } from "react";
import PhotoSlide from "./PhotoSlide";

function SliderPhoto({ slides }) {
  const [current, setCurrent] = useState(0);
  // const [Xtrans, setXtrans] = useState(0);
  const card = useRef(0);
  let shift = useRef(56);
  let cardWidth = useRef(318);
  // let padding = useRef(30);

  useEffect(() => {
    shift.current = window.matchMedia("(max-width: 700px)").matches ? 32 : 56;
    const interval = setInterval(() => {
      cardWidth.current = card.current.offsetWidth;
      // if (current === slides.length - 1) {
      //   setCurrent(0);
      //   setXtrans(0);
      // } else {
      //   setCurrent((prev) => prev + 1);
      //   setXtrans((prev) => prev + cardWidth.current + shift.current);
      // }
      // setCurrent((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
      setCurrent((prev) => (prev + 1) % slides.length);

      // padding.current = (window.innerWidth - cardWidth.current) / 2;
    }, 3000);
    return () => clearInterval(interval);
  }, [slides.length, current]);
  return (
    <div className="w-full overflow-hidden">
      <div
        className="flex h-[35rem] w-max items-center gap-8 px-4 transition-all duration-1000 ease-in-out md:gap-14"
        style={{
          transform: `translateX(-${current * (cardWidth.current + shift.current)}px)`,
          // transform: `translateX(-${Xtrans}px)`,
        }}
      >
        {slides.map((slide, i) => (
          <PhotoSlide
            key={i}
            i={i}
            slide={slide}
            card={card}
            aktual={current}
          />
        ))}
      </div>
      <div className="mt-4 flex justify-center gap-4 px-4 md:gap-8">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`h-2 w-10 cursor-pointer rounded-full transition-colors duration-1000 md:h-2 md:w-12 ${current === index ? "bg-white" : "bg-teal"}`}
            onClick={() => setCurrent(index)}
          />
        ))}
      </div>
    </div>
  );
}

export default SliderPhoto;
